// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style_breadcrumb__2mi3baL10eCIvs7PpcYIlI","breadcrumbLink":"style_breadcrumbLink__drS4enhDPjKtGvQn4l8_4"};